import React from 'react';
import '../components/grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const SecondcondExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Second Conditional</h2>

      <p>We use the second conditional to talk about imaginary, unlikely, or hypothetical situations in the present or future.</p>

      <h3><FaLightbulb /> Structure</h3>
      <p><strong>If + past simple, would + base verb</strong></p>
      <p>We use the past simple after <strong>if</strong>, and <strong>would</strong> + verb in the main clause.</p>

      <h4>Example structure:</h4>
      <div className="grammar-flex-table">
        {[
          ['If-clause (past simple)', 'Main clause (would + base verb)'],
          ['If I won the lottery', 'I would travel the world'],
          ['If she studied more', 'she would pass the test'],
          ['If it rained', 'we would stay at home'],
        ].map(([ifClause, mainClause], index) => (
          <div key={index} className={`grammar-flex-row${index === 0 ? ' header' : ''}`}>
            <div className="grammar-cell">{ifClause}</div>
            <div className="grammar-cell">{mainClause}</div>
          </div>
        ))}
      </div>

      <h3><FaLightbulb /> Examples</h3>
      <ul>
        <li>If I won the lottery, I would travel the world.</li>
        <li>If she studied more, she would pass the test.</li>
        <li>If it rained, we would stay at home.</li>
      </ul>

      <h3><FaLightbulb /> Notes</h3>
      <ul>
        <li>The <strong>if-clause</strong> can come first or second in the sentence.</li>
        <li>If the <strong>if-clause</strong> comes first, use a comma.</li>
        <li>If the <strong>if-clause</strong> comes second, no comma is needed.</li>
        <li>We often use <strong>were</strong> instead of <strong>was</strong> for all subjects in the second conditional (especially in formal English).</li>
      </ul>
    </div>
  );
};

export default SecondcondExplanation;
